module.exports = __webpack_public_path__ + "static/img/shlei.7731734.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlei.png
// module id = N7I+
// module chunks = 0